// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spectrum--dark .spectrum-IllustratedMessage-illustration {\n  color: rgb(110, 110, 110);\n  fill: currentColor;\n  stroke: currentColor;\n}\n", ""]);
// Exports
module.exports = exports;
